// extracted by mini-css-extract-plugin
export default {"AppGrid":"AppGrid_AppGrid__ZxiaC"};